import { Yield } from '../../abacus/interfaces/yield.interface'

export const riskYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
